import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import ToTopButton from './ToTopButton';
import ScrollToTop from './ScrollToTop';
import useTemplateScripts from '../hooks/useTemplateScripts';
import useLanguageFromUrl from '../hooks/useLanguageFromUrl';

const Layout = ({ children }) => {
    const location = useLocation();

    // Inicializar scripts del template
    useTemplateScripts();

    // Detectar y aplicar idioma desde la URL automáticamente
    useLanguageFromUrl();

    // Aplicar tema de marca según la ruta (sustituye al brand switcher)
    useEffect(() => {
        const path = location.pathname;
        const isRoot = path === '/' || /^\/(ca|es|en)\/?$/.test(path);
        let brand = 'matriz';
        if (
            isRoot ||
            path.includes('/studio') ||
            path.includes('/lab') ||
            path.includes('/renovation') ||
            path.includes('/reformas') ||
            path.includes('/empresa-reformas') ||
            path.includes('/reforma-integral') ||
            path.includes('/reforma-bano') ||
            path.includes('/reforma-cocina')
        ) {
            brand = 'lab';
        } else if (
            path.includes('/agency') ||
            path.includes('/search') ||
            path.includes('/sell') ||
            path.includes('/financing') ||
            path.includes('/community')
        ) {
            brand = 'agency';
        }
        document.documentElement.setAttribute('data-brand', brand);
    }, [location.pathname]);

    return (
        <>
            <ScrollToTop />
            <Menu />
            <Header />
            <main id="mxd-page-content" className="mxd-page-content">
                {children}
            </main>
            <Footer />
            <ToTopButton />
        </>
    );
};

export default Layout;
